'use strict';

// core version + modules:
import Swiper, {Navigation, Pagination, A11y} from 'swiper';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/a11y';

const PushNews = {
    els: null,
    init: function () {
        PushNews.els = document.querySelectorAll('.f-pushNews');
        if (PushNews.els && PushNews.els.length > 0) {
            PushNews.els.forEach(el => {
                if (window.matchMedia('(max-width: 1023px)').matches) {
                    PushNews.create(el);
                }
            });
        }
    },
    create: function (el) {
        const slider = el.querySelector('.swiper');

        let swiper = null;


        let modules = "";
        let navigation = null;
        let pagination = null;
        swiper = new Swiper(slider, {
            modules: [Navigation, Pagination, A11y],
            a11y: true,
            slidesPerView: "auto",
            loop: false,
            speed: 600,
            autoHeight:false,
            spaceBetween: 34,
            navigation: {
                prevEl: ".f-slider__navigation-prev",
                nextEl: ".f-slider__navigation-next",
            },
            pagination: {
                el: ".f-slider__pagination",
                clickable: true,
                bulletClass: `f-slider__pagination-bullet swiper-pagination-bullet`
            }
        });

    },
};

export default PushNews;